import { DialogTheme } from '@/components/Dialog/theme';
import { tw } from '@/utils/tw';
import BasePaymentCompletedDialogTheme from 'base/components/PaymentCompletedDialog/theme';

const Dialog = tw.theme({
  extend: DialogTheme,
  slots: {
    base: ['bg-logga-300', 'open:w-[420px]', 'open:md:w-[720px]'],
    contentWrapper: ['p-4', 'md:pb-4', 'gap-4'],
    content: ['text-content-sm'],
    headline: ['text-headline-lg'],
  },
});

const PaymentCompletedDialog = tw.theme({
  extend: BasePaymentCompletedDialogTheme,
});

export default Object.assign(PaymentCompletedDialog, {
  Dialog,
});
